import { createSelector } from 'reselect';
import { plannedShapeParameterSelector } from 'domain/Options/selectors/parameters';
import { freestandingHobsSelector } from 'domain/Options/selectors/operations';
import _ from 'lodash';
import { getSidesExcludingCorners } from 'pages/MainPage/PlanPage/shapeMeasurementsError';
import { calcfreestandingHobMeasurementsError } from 'pages/MainPage/CutoutsPage/freestandingHobMeasurementsError';
import { shapeFieldsSelector } from 'domain/Options/selectors/input';
import { configurationSelector } from 'domain/Options/selectors';

export const freestandingHobsMeasurementErrorSelector = createSelector(
  plannedShapeParameterSelector,
  shapeFieldsSelector,
  freestandingHobsSelector,
  configurationSelector,
  (shape, fieldValues, freestandingHobs, configuration) => {
    const shapeValue = shape.get('value');
    if (!shapeValue) return [];

    let measurements = _.mapValues(shapeValue.get('dimensions').toJS(), (dim, key) => {
      return (fieldValues[shapeValue.get('id')] && fieldValues[shapeValue.get('id')][key]) || dim.defaultValue;
    });
    const sides = getSidesExcludingCorners(shapeValue.get('id'), measurements);
    return calcfreestandingHobMeasurementsError(freestandingHobs, sides, configuration.get('freestandingHobDefaultWidth'), configuration.get('useImperialUnitMeasurementsInTheUI'));
  }
);

export const freestandingHobInvalidSelector = createSelector(
  freestandingHobsMeasurementErrorSelector,
  (errors) => errors.length > 0
);
